import React from "react";
import { LAYOUT_CONSTANTS } from "@/_self_managed/LAYOUT_CONSTANTS";
import { PopOutBadge } from "@/components/PopOutBadge";
import { colors2, UI_TITLE } from "oolib";

export const SM_PageHeader = ({ title, customLeftComp, customRightComp, betaBadge }) => {
  return (
    <div
      style={{
        padding: `3px ${LAYOUT_CONSTANTS.pagePadding}px 2px`,
        borderBottom: `1px solid ${colors2.grey10}`,
        position: "sticky",
        top:0,
        background: colors2.white,
        zIndex: 200,
      }}
    >
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        <div style={{ display: "flex", alignItems: "center", gap: LAYOUT_CONSTANTS.topBottomPadding+'px' }}>
          <div style={{ padding: `${LAYOUT_CONSTANTS.topBottomPadding}px 0`, display: 'flex', alignItems: 'center', gap: '4px' }}>
            <UI_TITLE>{title}</UI_TITLE>
            {betaBadge && <PopOutBadge/>}
          </div>
          {customLeftComp}
        </div>
        {customRightComp && (
          <div>
            {customRightComp}
          </div>
        )}
      </div>
    </div>
  );
};
